import { ERROR_SET, ERROR_CLEAR, ERROR_INPUT_CLEAR } from 'constants/actions';

import { dispatcher } from 'lib/redux';

export const errorSet = (data) => () => {
  dispatcher(ERROR_SET, {
    message: data.message || '',
    code: data.code || '',
    inputErrors: data.inputErrors
  });
};

export const errorClear = () => () => {
  dispatcher(ERROR_CLEAR);
};

export const errorInputClear = (name) => () => {
  dispatcher(ERROR_INPUT_CLEAR, name);
};
